import { of } from 'rxjs';
import { preloadAssetsShardSequentially } from './shard-sequential-loader.js';
import { promiseFactory } from './promise-factory.js';

export default class AssetLoader {
  constructor(config = {}) {
    this.config = config;
  }

  loadAssets(creative) {
    if (creative.assets.length === 0) {
      return of(creative);
    }

    return preloadAssetsShardSequentially(creative, promiseFactory);
  }
}
